// #PO_BUCKET_V1 (2026-10-02) — Bill: "we need assigned buckets or our own ledger assignments… a good KPI to
// monitor: WK / MO / Quarter / YR % assigned to SHOP." Every PO's cost goes to ONE place: a Unit #, a Job #,
// or a named bucket. The bucket list is DUC's own (seeded from the words Bob's 2026 PO log already used, plus
// Safety for Nathan); it lives in app_storage `po-buckets` so it can grow without a code change.
export const PO_BUCKETS_DEFAULT = ['Shop', 'Chemical', 'Consignment', 'Tooling', 'Fuel', 'Safety', 'Overhead'];
// old spellings in the history → today's bucket
const ALIAS = { CHEMICALS: 'Chemical', YARD: 'Shop', OFFICE: 'Overhead' };
const up = (x) => String(x == null ? '' : x).trim().toUpperCase().replace(/[`'.]+$/, '');
const listOf = (buckets) => (Array.isArray(buckets) && buckets.length ? buckets : PO_BUCKETS_DEFAULT);

// the bucket a typed / stored value stands for, or '' when it is not one
export function poBucketMatch(text, buckets) {
  const u = up(text); if (!u) return '';
  const list = listOf(buckets);
  const direct = list.find(b => up(b) === u); if (direct) return direct;
  const al = ALIAS[u]; return (al && list.find(b => up(b) === up(al))) || '';
}
// where a PO's cost went
export function poWhere(r, buckets) {
  if (r.ducType === 'fleet-unit') return { kind: 'unit', label: 'Unit #' };
  if (r.ducType === 'duc') return { kind: 'job', label: 'Job #' };
  const b = poBucketMatch(r.ducOrUnit, buckets);
  if (b) return { kind: 'bucket', label: b };
  return up(r.ducOrUnit) ? { kind: 'other', label: 'Other' } : { kind: 'none', label: 'Not assigned' };
}
// what a PO has cost so far: its invoices when it has any, else the typed actual, else the estimate
export function poSpendOf(r) {
  const inv = Array.isArray(r.invoices) ? r.invoices.filter(x => x && x.amount != null && x.amount !== '' && !isNaN(Number(x.amount))) : [];
  if (inv.length) return Math.round(inv.reduce((t, x) => t + Number(x.amount), 0) * 100) / 100;
  if (r.actual != null && r.actual !== '' && !isNaN(Number(r.actual))) return Number(r.actual);
  return r.estimate != null && r.estimate !== '' && !isNaN(Number(r.estimate)) ? Number(r.estimate) : 0;
}
// first day (YYYY-MM-DD) of this week (Monday) / month / quarter / year
export function poPeriodStart(period, now = new Date()) {
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (period === 'wk') d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  else if (period === 'mo') d.setDate(1);
  else if (period === 'qtr') { d.setMonth(Math.floor(d.getMonth() / 3) * 3); d.setDate(1); }
  else { d.setMonth(0); d.setDate(1); }
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
// share of spend by where it went, for POs dated in the period
export function poWhereSummary(rows, buckets, period, now = new Date()) {
  const from = poPeriodStart(period, now);
  const m = new Map(); let total = 0, n = 0;
  (rows || []).forEach(r => {
    const dt = String(r.date || '').slice(0, 10); if (!dt || dt < from) return;
    const w = poWhere(r, buckets); const a = poSpendOf(r);
    const o = m.get(w.label) || { label: w.label, kind: w.kind, amt: 0, n: 0 };
    o.amt += a; o.n++; m.set(w.label, o); total += a; n++;
  });
  const parts = [...m.values()].map(o => ({ ...o, amt: Math.round(o.amt * 100) / 100, pct: total > 0 ? (o.amt / total) * 100 : 0 })).sort((a, b) => b.amt - a.amt);
  return { from, total: Math.round(total * 100) / 100, n, parts };
}
